import { memo } from 'react';
import DOMPurify from 'dompurify';

const ProductHazardousInformation = memo(
    ({ hazardStatements }: { hazardStatements?: string }) => {
        return (
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(hazardStatements ?? ''),
                }}
            ></div>
        );
    }
);

export default memo(ProductHazardousInformation);
